import { linkRegexConfig } from '../utils/commonFields';

export const ButtonFields = [
  {
    name: 'text',
    type: 'text',
    required: true,
  },
  {
    name: 'url',
    type: 'url',
    required: true,
  },
  {
    name: 'newTab',
    type: 'boolean',
    defaultValue: false,
    helperText: 'Default to false',
  },
];

export const TitleFields = [
  {
    name: 'content',
    helperText: 'Type the desired title.',
    type: 'text',
  },
  {
    name: 'titleHTMLTag',
    type: 'string',
    defaultValue: 'h2',
    helperText: 'Defaults to h2',
    enum: ['h1', 'h2', 'h3'],
  },
  {
    name: 'titleSize',
    type: 'string',
    helperText: 'Select the title size. Defaults to the corresponding HTML tag.',
    enum: ['extraLarge', 'large', 'medium', 'small'],
  },
  {
    name: 'titleWeight',
    type: 'string',
    defaultValue: 'normal',
    helperText: 'Select the title weight. Default is normal',
    enum: ['normal', 'bold'],
  },
];

export interface ITitle {
  content: string;
  titleHTMLTag?: 'h1' | 'h2' | 'h3';
  titleSize?: 'extraLarge' | 'large' | 'medium' | 'small';
  titleWeight?: 'light' | 'normal' | 'medium' | 'bold' | 'black';
}

export const MarginField = {
  name: 'margin',
  type: 'boolean',
  defaultValue: false,
  helperText: 'Turn on to add margin to the bottom of the component',
};

export const OutlineMarginField = {
  name: 'outlineMargin',
  type: 'boolean',
  defaultValue: false,
  helperText: 'Turn on to add margin to the outline of the component',
};

export const AnchorField = {
  name: 'anchorLinkID',
  friendlyName: 'Anchor Link ID',
  type: 'string',
  helperText: 'Anchor link can only contain letters, numbers, dashes, or underlines',
  regex: {
    pattern: '^[a-zA-Z0-9-_]+$',
    options: 'g',
    message: 'Anchor link can only contain letters, numbers, dashes, or underlines',
  },
};

export const ActionsField = {
  name: 'actions',
  type: 'list',
  subFields: [
    {
      name: 'isDropdownButton',
      type: 'boolean',
      defaultValue: false,
      friendlyName: 'Is this a dropdown button?',
      helperText:
        'Please keep the Href field empty if it is a dropdown button. A dropdown button is a button that on hover displays multiple actions to be chosen.',
    },
    {
      name: 'label',
      type: 'text',
    },
    {
      name: 'href',
      friendlyName: 'url',
      type: 'url',
      regex: { ...linkRegexConfig },
      showIf: `!options.get('isDropdownButton')`,
    },
    {
      name: 'variant',
      friendlyName: 'Desktop variant',
      type: 'text',
      enum: ['link', 'primary', 'secondary'],
      defaultValue: 'primary',
    },
    {
      name: 'color',
      friendlyName: 'Desktop color',
      type: 'text',
      enum: ['light', 'dark'],
      defaultValue: 'dark',
    },
    {
      name: 'mobileVariant',
      type: 'text',
      enum: ['link', 'primary', 'secondary'],
      defaultValue: 'primary',
    },
    {
      name: 'mobileColor',
      type: 'text',
      enum: ['light', 'dark'],
      defaultValue: 'dark',
    },
    {
      name: 'actions',
      type: 'list',
      subFields: [
        {
          name: 'label',
          type: 'text',
        },
        {
          name: 'href',
          type: 'url',
          regex: { ...linkRegexConfig },
        },
      ],
      showIf: `options.get('isDropdownButton')`,
    },
  ],
};

export const MaxWidthField = {
  name: 'isSetMaxWidth',
  friendlyName: 'MaxWidth',
  helperText: 'turn on to set the max width(1440px) to the component, default value is true',
  type: 'boolean',
  defaultValue: true,
};

export interface IListItem {
  itemLabel: string;
  url: string;
  helpLink: {
    label: string;
    url: string;
  };
}

export interface IGridTitle {
  gridLabel: string;
  gridUrl: string;
}

export interface IGridItems {
  itemLabel: string;
  url: string;
  icon: string;
  alt: string;
}

export interface IDataShowroom {
  storeInfoBlockHeroComingSoonCtaLink: string;
  additionalAddressDescription: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  displayName1?: string;
  displayName2?: string;
  id?: string;
  googlePlacesId: string;
  hours: string;
  latitude: string;
  timezoneId?: string;
  timezoneName?: string;
  timezoneAbreviation?: string;
  longitude: string;
  locationImage: string;
  mobileLocationImage: string;
  locationImageAltText?: string;
  phoneNumber: string;
  seoSchemaAreaServed: string;
  seoSchemaDescription: string;
  setsterLocationId: string;
  state: string;
  stateDropdownValue: string;
  storeDescriptionText: string;
  storePageLink: string;
  zipCode: number | string;
  storeInfoBlockHeroHeader: string;
  status: ShowroomStatusOptions;
  searchInput?: string;
}

export enum ShowroomStatusOptions {
  Open = 'Open',
  PreBook = 'Pre-Book',
  ComingSoon = 'Coming Soon',
}
